import {Box} from '@primer/react-brand'
import {ContentfulTestimonial} from '../../../../components/contentful'
import type {PrimerComponentTestimonial} from '../../../../lib/types/contentful'

export function Testimonial({entry}: {entry: PrimerComponentTestimonial}) {
  return (
    <Box
      borderRadius="medium"
      padding="normal"
      backgroundColor="subtle"
      marginBlockStart="spacious"
      marginBlockEnd="spacious"
    >
      <ContentfulTestimonial component={entry} quoteMarkColor="purple" />
    </Box>
  )
}

try{ Testimonial.displayName ||= 'Testimonial' } catch {}